// Constants
import {
  BACK_CUSTOM_ACTION,
  DROP_MODAL_CUSTOM_ACTION,
  POP_STATE_CUSTOM_ACTION,
  UNLOAD_CUSTOM_ACTION,
} from './constants/header-layout-log.handlers.constants';
import {
  INTENTIONAL_NAVIGATION,
  INTENTIONAL_NAVIGATION_OFF,
  INTENTIONAL_NAVIGATION_ON,
} from '../constants/header-layout.constants';
// Types
import {
  HeaderLayoutMethodsHandlersType,
  HeaderLayoutBuilderHandlersType,
  HeaderLayoutEventBuilderHandlersType,
} from './types/header-layout.handlers.type';

const backButtonClickHandler = ({
  handleTrackClickBack,
  handleSendCustomActionEvent,
  onHeaderBackClick,
  setShowDropModal,
  setOnHeaderBackClick,
}: HeaderLayoutBuilderHandlersType): void => {
  handleSendCustomActionEvent(onHeaderBackClick ? BACK_CUSTOM_ACTION : DROP_MODAL_CUSTOM_ACTION);
  handleTrackClickBack();
  if (onHeaderBackClick) onHeaderBackClick();
  else setShowDropModal(true);
  setOnHeaderBackClick(null);
};

const closeDropModalActionClickHandler = ({
  handleTrackCloseIcon,
  setShowDropModal,
}: HeaderLayoutBuilderHandlersType): void => {
  handleTrackCloseIcon();
  setShowDropModal(false);
};

const onLinkCloseDropModalHandler = ({
  handleTrackCancelButton,
  setShowDropModal,
}: Omit<HeaderLayoutBuilderHandlersType, 'handleSendCustomActionEvent'>): void => {
  handleTrackCancelButton();
  setShowDropModal(false);
};

const popState = (
  handleSendCustomActionEvent: HeaderLayoutBuilderHandlersType['handleSendCustomActionEvent']
): void => {
  handleSendCustomActionEvent(POP_STATE_CUSTOM_ACTION);
  window.history.pushState(null, '', window.location.href);
};

const beforeUnload = ({
  event,
  handleSendCustomActionEvent,
}: HeaderLayoutEventBuilderHandlersType): void => {
  if (
    !localStorage.getItem(INTENTIONAL_NAVIGATION) ||
    localStorage.getItem(INTENTIONAL_NAVIGATION) !== INTENTIONAL_NAVIGATION_ON
  ) {
    localStorage.setItem(INTENTIONAL_NAVIGATION, INTENTIONAL_NAVIGATION_OFF);
    handleSendCustomActionEvent(UNLOAD_CUSTOM_ACTION);
    // Prevent navigation by pushing the current state back into the history stack
    window.history.pushState(null, '', window.location.href);

    event.preventDefault();
    event.returnValue = ''; // Required to block navigation
  }
};

const HeaderLayoutHandlers = ({
  handleSendCustomActionEvent,
  ...props
}: HeaderLayoutBuilderHandlersType): HeaderLayoutMethodsHandlersType => ({
  handleCloseDropModalActionClick: () =>
    closeDropModalActionClickHandler({ ...props, handleSendCustomActionEvent }),
  handleBackButtonClick: () => backButtonClickHandler({ ...props, handleSendCustomActionEvent }),
  handlePopState: () => popState(handleSendCustomActionEvent),
  handleOnLinkCloseDropModal: () => onLinkCloseDropModalHandler({ ...props }),
  handleBeforeUnload: (event: BeforeUnloadEvent) =>
    beforeUnload({ event, handleSendCustomActionEvent }),
});

export { HeaderLayoutHandlers };
